import {all} from "redux-saga/effects";
import AppSagas from "@/Redux/App/AppSagas";
//import AuthSagas from './Auth/AuthSagas';
//import SystemSagas from './System/SystemSagas';
import DispositionSagas from "@/Redux/Disposition/DispositionSagas";
import BookingSagas from "@/Redux/Booking/BookingSagas";
import SystemSagas from "@/Redux/System/SystemSagas";
import AuthSagas from "@/Redux/Auth/AuthSagas";
import QuerySagas from "@/Redux/Query/QuerySagas";
import RateSagas from "@/Redux/Rate/RateSagas";
//import SocketSagas from './Socket/SocketSagas'

export default function* rootSaga() {
    yield all([
        AppSagas(),
        //UserSagas(),
        BookingSagas(),
        AuthSagas(),
        SystemSagas(),
        DispositionSagas(),
        QuerySagas(),
        RateSagas(),
        //        SocketSagas()
    ]);
}
